angular.module('stack.common.api.validation.ValidationService', [
  'global'
])

/**
 * The ValidationService service stores methods used to access
 * system APIs.
 *
 * @class ValidationService
 * @constructor
 * @module stack.common.api.ValidationService
 */
.factory('ValidationService', [
  '$http',
  'GLOBAL',
  function ($http, GLOBAL) {
    'use strict';

    var service = {

      /**
       * Collection of schemas
       * @property schemas
       * @type {Array<Object>}
       */
      schemas: [],


      /**
       * Verifies JSON data is well formed
       *
       * @param {Object} data - JSON data
       */
      lintData: function lintData(data) {
        var result = {
          data: {},
          valid: false,
          errors: []
        };
        var dataAsString = JSON.stringify(data);

        try {
          result.data = jsonlint.parse(dataAsString);
          result.valid = true;
        } catch (err) {
          result.errors.push({
            message: err.message
          });
        }

        return result;
      },

      /**
       * Uses tv4 to validate JSON data against a schema
       *
       * @param {Object} data - Data to validate
       * @param {Object} schema - Schema to use for validation
       * @param {Function} callback - Callback method to set state
       * @return {Object} Result of validation
       */
      testAgainstSchema: function testAgainstSchema(data, schema, callback) {
        var result = tv4.validateMultiple(data, service.schemas[schema]);

        if (callback) {
          callback(result);
        }

        return result;
      },

      /**
       * Loads schemas based on the provided array
       *
       * @param {Array<string>} schemas - Array of schema files to load
       */
      loadAPISchemas: function loadAPISchemas(schemas) {
        _.forEach(schemas, function (schema) {
          service.loadSchema(GLOBAL.schemasPath + schema + '.json', schema);
        });
      },

      /**
       * Loads a schema based on the provided file path
       *
       * @param {string} file - Schema file to load
       * @param {string} schema - Schema label
       */
      loadSchema: function loadSchema(file, schema) {
        $http
          .get(file)
          .then(function (response) {
            service.schemas[schema] = response.data;
            return;
          })
          .catch(function (err) {
            console.log(err);
          });
      }

    };

    return service;
  }
]);
